module.exports = __webpack_public_path__ + "static/media/sql-server.b90b182d.png";